<template>
  <div
    class="app-radio"
  >
    <input
      :id="id"
      :name="name"
      :value="value"
      :disabled="disabled"
      :checked="checked"
      type="radio"
      class="app-radio__input"
      @change="onChange"
    >
    <label
      :for="id"
      class="app-radio__label"
    >
      <slot/>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppRadio',
  model: {
    prop: 'modelProp',
    event: 'change',
  },
  props: {
    modelProp: {
      type: [String, Number],
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      default: 'option',
    },
    value: {
      type: [String, Number],
      default: 'val',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked() {
      return this.modelProp === this.value;
    },
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-radio {
    display: flex;
    align-items: center;
    min-height: 23px;
    &__input {
      display: none;
      &:checked {
        + .app-radio__label {
          color: #000000;
          &:after {
            opacity: 1;
          }
          &:before {
            border-color: blue;
          }
        }
      }
      &:disabled {
        + .m-radio__label {
          cursor: default;
          &:before {
            border: 1px solid #000000;
          }
        }
      }
    }
    &__label {
      color: gray;
      position: relative;
      transition: color .3s ease;
      display: block;
      padding-left: 30px;
      cursor: pointer;
      &:before, &:after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      &:before {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid #000;
        left: 0;
      }
      &:after {
        width: 10px;
        height: 10px;
        background-color: blue;
        border-radius: 50%;
        margin-left: 5px;
        left: 0;
        opacity: 0;
        transition: all .2s ease;
      }
    }
  }
</style>
